import type { Event } from 'models';
import { withErrorBoundary } from 'ui';
import type { EventFeedbackOptions } from '../event-feedback';
import { EventDetailCanceled } from './event-detail-canceled';
import { EventDetailDefault } from './event-detail-default';

type P = {
  event: Event;
  feedbackOptions: EventFeedbackOptions;
};

// TODO: rename to ...DetailContent? then rename also children
const EventDetail = ({ event, feedbackOptions }: P) => {
  const { status } = event;

  switch (status) {
    case 'active':
    case 'draft':
      return <EventDetailDefault event={event} feedbackOptions={feedbackOptions} />;
    case 'canceled':
      return <EventDetailCanceled event={event} />;
  }
};

export default withErrorBoundary(EventDetail);
